// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"9d5f0be0","206":"9c5719ac","762":"a79fa641","922":"d90255dd"}[chunkId] + ".css";
};